export default {
	generals: {
		login: 'Login',
		reset_password: 'Reset password',
		sign_up: 'Sign up',
		write_something: 'Write something',
	},
	packages: {
		dashboard: 'Dashboard',
		management: 'Management',
		projects: 'Projects',
		cms: 'CMS',
	},
	resources: {
		comments: 'Comentarios',
		profile: {
			skills: 'habilidades',
			equipment: 'equipamiento',
			name: 'nombre',
		},
		products: {
			product: 'producto | productos',
			attribute: 'atributo | atributos',
			type_field: 'tipo de campo',
			value: 'valor',
			operable: 'operable',
			base_price: 'precio base',
			sale_price: 'precio venta',
			purchase_price: 'precio compra',
			price: 'precio',
			taxes: 'impuestos',
			save: 'ahorro',
			discount: 'descuento',
			total: 'total',
			total_measurement_unit: 'medidas totales',
			unit_price: 'u. price',
		},
		tasks: {
			task: 'tarea | tareas',
		},
		categories: {
			category: 'categoría',
		},
		budgets: {
			budget: 'budget',
		},
		orders: {
			order: 'order'
		},
		invoices: {
			invoice: 'invoice'
		},
		partners: {
			partner: 'partner | partners',
		},
	},
	interface: {
		new: 'nuevo | nuevos',
		detail: 'detalle | detalles',
		setting: 'configuración | configuraciones',
		image: 'imagen | imágenes',
		doc: 'document | documents',
		title: 'título | títulos',
		short_title: 'título corto',
		description: 'descripción | descripciones',
		short_description: 'descripción corta',
		keywords: 'tags',
		status: 'estado | estados',
		email_address: 'email address',
		password: 'password',

		actions: {
			show: 'Ver',
			edit: 'Editar',
			call: 'Llamar',
			add: 'Añadir',
			quit: 'Quitar',
			search: 'Buscar',
			select: 'Select',
		},

		datatable: {
			info_template: 'Showing {from} to {to} of {total} entries',
			no_data_template: 'No relevant data',
			records_per_page: 'Records per page',
		}
	},
	messages: {
		done: 'Done',
		attention: 'Attention',
		notify: 'Notify',

		cant_deleted: 'Can\'t be deleted',
		item_can_not_be_retrieved: 'The item can\'t be retrieved',

		the_dates_are_incorrect: 'The dates are incorrect',
		notify_the_task_staff_by_email: 'Notify the task staff by e-mail',
		notifications_sent_correctly: 'Notifications sent correctly',
		task_has_closures_of_users_clients: 'The task has closures of users and/or clients',
		notifications_be_marked_read: 'Notifications will be marked as read',
		actions_be_applied_selected_items: 'The actions will be applied to the selected items',
		closure_be_made: 'This closure will be made',
		staff_has_tasks_on_dates: 'The staff has assigned tasks on these dates',

		the_schedule_will_be_marked_as_done: 'The schedule will be marked as done',
		the_schedule_will_be_marked_as_not_done: 'The schedule will be marked as NOT done',

		budget_will_be_created: 'A budget will be created',
		formula_will_be_created: 'A formula will be created',

		purchase_orders_will_be_added: 'Purchase orders will be added',
		purchase_order_will_be_added: 'A purchase order will be added',
	},
	settings: {
		docs: {
			'budget-show': 'Show budget',
			'budget-edit': 'Edit budget',
			'budget-pdf': 'PDF budget',
			'order-show': 'Show order',
			'order-edit': 'Edit order',
			'invoice-show': 'Show invoice',
			'invoice-edit': 'Edit invoice',
			'invoice-pdf': 'PDF invoice',
			'agreement-show': 'Show agreement',
			'agreement-edit': 'Edita agreement',
			'delivery-note-show': 'Vista albarán',
			'delivery-note-edit': 'Editar albarán',
			'delivery-note-pdf': 'PDF albarán',
		}
	}
}


// WEBPACK FOOTER //
// ./src/packages/lang/languages/en.js